module.exports = __webpack_public_path__ + "static/media/sendmails.ea922ed3.png";